import React, { useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import styled from 'styled-components';
import { theme, media, color } from '../../theme';
import { vr } from '../../utils';
import SearchIcon from '../../img/search.inline.svg';

export const SearchBox = connectSearchBox(({ refine, currentRefinement, className, onFocus }) => {

  const [ searchValue, setSearchValue ] = useState('');

  function search() {
    if (searchValue.length > 0) refine(searchValue);
  }

  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      <label htmlFor="searchBox">
        <input
          id="searchBox"
          name="searchBox"
          type="text"
          placeholder="Søg og afslut med Enter"
          aria-label="Søgning"
          onKeyPress={(e) => { if (e.key === 'Enter') search(); }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={onFocus}
        />
      </label>
      <button type="submit" className="btn green-fill no-glow" onClick={() => search()}>
        <SearchIcon />
      </button>
      {/* <SearchIcon className="SearchIcon" /> */}
    </Form>
  );
});

const Form = styled.form`
  display: flex;
  flex-direction: row;
  max-width: ${theme.contentMaxWidth};

  label {
    display: inline-block;
    width: 100%;

    input {
      height: 75px;
    }
  }

  button {
    height: 74px;
    box-sizing: border-box !important;
    position: relative;
    z-index: 50;
    margin-left: -1px;
    line-height: 1;

    svg {
      width: 1.5em;
      height: 1.5em;

      path {
        fill: #fff;
      }
    }
  }
`;
